import React, { useState } from 'react';
import '../styles/pages/AdvertisePrinting.css';
import FlexPortfolio from './FlexPortfolio';
import FlexServicesSection from '../components/FlexServicesSection';
import HeroSection from '../components/HeroSection';

const AdvertisePrinting = () => {
  const [activeSection, setActiveSection] = useState(1);

  const advertiseTypes = [
    {
      id: 1,
      title: "Supack",
      icon: "📦",
      description: "Durable and versatile packaging solutions for branding and product display. Perfect for retail and promotional needs.",
      features: [
        "High-quality printing",
        "Customizable sizes",
        "Eco-friendly materials",
        "Weather-resistant",
        "Easy assembly",
        "Cost-effective"
      ],
      specifications: {
        material: "Cardboard with PVC coating",
        thickness: "300-500 GSM",
        width: "Custom sizes",
        durability: "2-3 years",
        applications: "Product packaging, displays"
      },
      image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=500&h=350&fit=crop",
      color: "#10b981",
      bestFor: ["Retail packaging", "Promotional displays", "Product launches", "Events"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1560472355-536de3962603?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 2,
      title: "Canopy",
      icon: "🏕️",
      description: "Custom canopy solutions for outdoor events and branding. Provides shade and visibility with vibrant designs.",
      features: [
        "UV-resistant fabric",
        "Wind-resistant design",
        "Easy setup and transport",
        "Custom branding",
        "Waterproof coating",
        "Durable frame"
      ],
      specifications: {
        material: "PVC-coated polyester",
        thickness: "400 GSM",
        width: "Up to 6m",
        durability: "3-5 years outdoor",
        applications: "Events, exhibitions, outdoor advertising"
      },
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=500&h=350&fit=crop",
      color: "#f97316",
      bestFor: ["Outdoor events", "Trade shows", "Promotional booths", "Sports events"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921140401-e21688ae4309?w=400&h=300&fit=crop",
        ]
      }
    },
    {
      id: 3,
      title: "Acrylic Board",
      icon: "🔳",
      description: "Crystal-clear acrylic boards for professional signage and displays. Offers durability and modern aesthetic.",
      features: [
        "Crystal clear transparency",
        "Scratch-resistant surface",
        "Lightweight design",
        "Easy mounting",
        "Custom shapes",
        "High gloss finish"
      ],
      specifications: {
        material: "Acrylic (PMMA)",
        thickness: "3-10mm",
        width: "Custom sizes",
        durability: "10+ years indoor",
        applications: "Signage, displays, partitions"
      },
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=350&fit=crop",
      color: "#6366f1",
      bestFor: ["Office signage", "Retail displays", "Museum exhibits", "Corporate branding"],
      portfolio: {
        gallery: [
          "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=400&h=300&fit=crop",
          "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?w=400&h=300&fit=crop",
        ]
      }
    }
  ];

  return (
    <div className="advertise-printing-page">
      <HeroSection
        heroTitle="Advertise Printing Services"
        heroSubtitle="Enhance your brand visibility with our comprehensive advertising printing solutions. From packaging to signage, we deliver impactful results."
        onExploreClick={() => {
          const servicesSection = document.querySelector('.services-section');
          if (servicesSection) {
            servicesSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        onGetQuoteClick={() => {
          const contactSection = document.getElementById('contact');
          if (contactSection) {
            contactSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <FlexServicesSection
        flexTypes={advertiseTypes}
        title="Our Premium Advertise Printing Solutions"
        subtitle="Enhance your brand visibility with our comprehensive advertising printing solutions. From packaging to signage, we deliver impactful results."
      />

      <FlexPortfolio
        activeSection={activeSection}
        portfolioData={advertiseTypes.map(advertiseType => ({
          id: advertiseType.id,
          title: advertiseType.title,
          icon: advertiseType.icon,
          gallery: advertiseType.portfolio?.gallery || []
        }))}
        title="Our Advertise Printing Portfolio"
        subtitle="Explore our diverse advertising printing services and see the quality that sets us apart"
      />
    </div>
  );
};

export default AdvertisePrinting;
